var getCookie = function(name) {
    return decodeURIComponent(document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' + encodeURIComponent(name).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1')) || null;
};

var setCookie = function(name, value) {
    document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value) + '; expires=Thu, 18 Dec 2030 12:00:00 UTC domain=' + document.domain + '; path=/';
    console.log(document.domain);
};

var removeCookie = function(name) {
    document.cookie = encodeURIComponent(name) + '=; expires=Thu, 01-Jan-70 00:00:01 GMT; domain=' + document.domain + '; path=/';
};

function displayCookieLawNotification() {
	var notification = '<div class="eu-cookie-law container">' +
		'This website uses cookies to ensure you get the best experience on our website.' +
		'<button>Got It!</button><a class="learn-more" href="/policies">Learn more...</button>' +
	'</div>';
	$('body').append(notification);
}

$(function() {
	if(!getCookie('euCookieLawPassed')) {
        displayCookieLawNotification();
	}
	$('.eu-cookie-law button').on('click', function() {
		$('.eu-cookie-law').css('display', 'none');
		setCookie('euCookieLawPassed', true);
	});
});
